import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export class Facilities {
  public hasShop: boolean;
  public hasParking: boolean;
  public hasFamilyFriendly: boolean;
  public hasMobileCard: boolean;
  public hasBar: boolean;
  public hasAudioGuide: boolean;
  public hasHandicapFriendly: boolean;
  public hasSchoolOffers: boolean;
  public hasChildFriendlySwimmingPool: boolean;
  public hasDogsAllowed: boolean;
  public hasGastronomicOffer: boolean;
  public hasHeatedPool: boolean;
  public hasVolley: boolean;
  public hasChildrensPlayground: boolean;
  public hasSwimLanes: boolean;
  public hasLoungerUmbrellaHire: boolean;
  public hasLifeguard: boolean;
  public hasPedalBoatHire: boolean;
  public hasWaterSlide: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FacilitiesService {

  constructor(private _http: HttpClient) { }


  public getOrganizationFacilities(orgId: string) {
    let paramas = new HttpParams();
    paramas = paramas.append('orgId', orgId);
    return this._http.get<Facilities>(environment.serverUrl + 'facility/getByOrganization', {
      params: paramas,
    }).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  /**
   * updateFacilities
   */
  public updateFacilities(orgId: string, facilities: any) {
    console.log(facilities);
    return this._http
      .post<Facilities>(
        environment.serverUrl + 'facility/update',
        {
          'orgId': orgId,
          'facilities': facilities
        }
      ).pipe(
        map(responseData => {
          console.log(responseData);
        }),
        catchError(errorRes => {
          return throwError(errorRes);
        })
      );
  }

}
